import React from 'react';
import { Select } from 'antd';
import { NumberFormatStyle } from '@shared/utils/constants';

const ExportNotationSelect = ({
	value,
	onChange,
	label,
}: {
	value: NumberFormatStyle;
	onChange: (v: NumberFormatStyle) => void;
	label?: string;
}) => (
	<div>
		{label && <div>{label}</div>}

		<Select<NumberFormatStyle>
			allowClear={false}
			value={value}
			onChange={onChange}
			options={[
				{ label: 'UK / US (1,234.56)', value: NumberFormatStyle.UkUs },
				{ label: 'European (1.234,56)', value: NumberFormatStyle.European },
			]}
		/>
	</div>
);

export default ExportNotationSelect;